import {
  ShowFilterStoreAction,
  ShowFilterStoreType,
} from './showFilterStore.types';

export const INITIAL_SHOW_FILTER = {
  showFilter: false,
};

const showFilterStore = (
  state: ShowFilterStoreType,
  action: ShowFilterStoreAction
): ShowFilterStoreType => {
  switch (action.type) {
    case 'INITIAL': {
      return { ...state, ...action.payload };
    }
    default:
      throw new Error();
  }
};

export default showFilterStore;
